module.exports = __webpack_public_path__ + "img/fr-ds.31fd72da.svg";